import OptInPolicyType from '@/enums/OptInPolicyType';

export default class OptInData {
  public PolicyType: OptInPolicyType = 0;

  public OptInEmail: boolean = false;

  public OptInPhone: boolean = false;

  public OptInPost: boolean = false;

  public OptInSms: boolean = false;

  public OptInCar: boolean = false;

  public OptInApp: boolean = false;

  public PublishedPolicyId: string = '';

  public ConsentDate: Date = new Date();
}
